import { userDataAtom } from '@/global-store';
import { api } from '@http/constants';
import fetchWrapper from '@/http/fetchWrapper';
import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import type { TeamEffectiveRightsByProductType } from '@eye-able/types';

export interface MyEffectiveRights {
  userId: number;
  effectiveRights: TeamEffectiveRightsByProductType;
}

/**
 * Fetches the current user's own per-license viewer/editor access levels.
 */
export function useEffectiveUserRights() {
  const user = useAtomValue(userDataAtom);
  const userId = user?.id;

  const { data } = useQuery({
    enabled: !!userId,
    queryKey: [api.myEffectiveRights, userId],
    queryFn: () => fetchWrapper.get<MyEffectiveRights>(api.myEffectiveRights),
  });

  return data?.effectiveRights ?? null;
}
